import { SVGProps } from 'react';

export function ChevronDoubleDownLight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <path d="M16.354 6.94a.5.5 0 0 1 0 .706L12 12L7.646 7.646a.5.5 0 1 1 .708-.707L12 10.586l3.646-3.647a.5.5 0 0 1 .708 0"></path>
        <path d="M16.354 12.146a.5.5 0 0 1 0 .708L12 17.207l-4.354-4.353a.5.5 0 0 1 .708-.708L12 15.793l3.646-3.647a.5.5 0 0 1 .708 0"></path>
      </g>
    </svg>
  );
}
